import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const PieChartComponent = ({ data = [], total, lable, colors=[] }) => {
    
      
    // Custom label to show total in center
    const renderCenteredLabel = () => {
        return (

            data ? <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize={20}
                fontWeight="bold"
                fill="#333"
            >
                Total: {total}
            </text > : <></>
        );
    };

    return (
        <ResponsiveContainer width="100%" height={400}>
            <PieChart>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={180}
                    innerRadius={130}
                    fill="#8884d8"
                    dataKey="value"
                >
                    {data.length&&data?.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                </Pie>
                {renderCenteredLabel()}
                <Tooltip
                    formatter={(value, name) => [`${value} ${lable}`, name]}
                />
                <Legend
                    verticalAlign="bottom"
                    height={32}
                    formatter={(value) => {
                        const active = data.find(_state => _state.name === value) || {}
                        return `${active?.value} ${active?.name}`
                    }

                    }
                />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default React.memo(PieChartComponent);
